import React from "react";
import { Link } from "react-router-dom";
import { useGetOpenExamDietsQuery } from "../../api/examsApi";

function fmt(dt: string) {
  try {
    return new Date(dt).toLocaleString();
  } catch {
    return dt;
  }
}

export default function OpenExamDietsPage() {
  const { data = [], isLoading, error, refetch } = useGetOpenExamDietsQuery();

  return (
    <div className="p-4 md:p-6 max-w-5xl mx-auto">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="text-xl font-semibold text-gray-900">Exam Diets</h1>
          <p className="text-sm text-gray-600 mt-1">
            Select an open diet to see available exams and apply.
          </p>
        </div>

        <Link
          to="/exams/applications"
          className="px-4 py-2 rounded-lg bg-gray-900 text-white hover:bg-gray-800 text-sm"
        >
          My Applications
        </Link>
      </div>

      <div className="mt-5">
        {isLoading ? (
          <div className="text-sm text-gray-600">Loading...</div>
        ) : error ? (
          <div className="text-sm text-rose-700">
            Failed to load.
            <button className="ml-2 underline" onClick={() => refetch()}>
              retry
            </button>
          </div>
        ) : data.length === 0 ? (
          <div className="text-sm text-gray-600">
            No open exam diets at the moment.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {data.map((d) => (
              <Link
                key={d.id}
                to={`/exams/diets/${d.id}`}
                className="border rounded-2xl p-4 hover:bg-gray-50 transition"
              >
                <div className="font-semibold text-gray-900">{d.title}</div>
                <div className="text-xs text-gray-500 mt-2">
                  Open: {fmt(d.applications_open_at)}
                </div>
                <div className="text-xs text-gray-500">
                  Close: {fmt(d.applications_close_at)}
                </div>
                <div className="mt-3 inline-flex text-xs rounded-full bg-emerald-50 text-emerald-700 px-2 py-1">
                  Open for applications
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
